import { type QueryClient, QueryClientProvider } from "@tanstack/react-query"
import posthog from "posthog-js"
import { PostHogProvider } from "posthog-js/react"

function Providers({
	children,
	queryClient,
}: {
	children: React.ReactNode
	queryClient: QueryClient
}) {
	return (
		<PostHogProvider client={posthog}>
			<QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
		</PostHogProvider>
	)
}

export { Providers }
